import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { PmdModal } from '@app/shared/propeller';

@Component({
  selector: 'app-invoice-reject-reason-modal',
  templateUrl: './invoice-reject-reason-modal.component.html'
})
export class InvoiceRejectReasonModalComponent {
  @Input() rejectionReasons: { name: string, id: string }[] = [];
  @Input() submitting = false;
  @Output() confirmed = new EventEmitter<{ rejectReasonId: string, otherReason: string }>();

  @ViewChild('RejectInvoice') RejectInvoice: PmdModal;

  selectedReasonId: string = null;
  otherReason = '';

  show(): void {
    this.selectedReasonId = null;
    this.otherReason = '';
    this.RejectInvoice?.show();
  }

  hide(): void {
    this.RejectInvoice?.hide();
  }

  submit(): void {
    if (!this.selectedReasonId || this.submitting) {
      return;
    }

    this.confirmed.emit({
      rejectReasonId: this.selectedReasonId,
      otherReason: this.otherReason
    });
  }
}
